// ------------------------------------------------------------------------------
// name: form
// author: mudas
// created: 2024-10-16
// ------------------------------------------------------------------------------

/**
 * 将指定键值对象转换为 FormData 结构
 * @param data
 * @return {FormData}
 */
export const transFormData = (data?: Record<string, any>): FormData => {
  const formData = new FormData();

  if (!!data) {
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
  }

  return formData;
};
